<template>
  <b-navbar fixed-top type="is-primary">
    <template slot="brand">
      <b-navbar-item
        tag="router-link"
        :to="{path: '/'}"
        class="has-text-weight-bold"
      >
        <img
          src="@/assets/logo-backoffice.svg"
          width="166"
          height="60"
          alt="SST Backoffice"
        />
      </b-navbar-item>
    </template>
    <template slot="start">
      <b-navbar-item tag="router-link" :to="{path: '/'}">Home</b-navbar-item>
      <b-navbar-item tag="router-link" to="/angebote" v-if="!onlyStatistics"
        >Angebote</b-navbar-item
      >
      <b-navbar-item tag="router-link" to="/provision" v-if="supervisor"
        >Provision</b-navbar-item
      >
      <b-navbar-item
        tag="router-link"
        to="/promotioncodes"
        v-if="(elevated || promoEnabled) && !onlyStatistics"
        >Promotioncodes</b-navbar-item
      >
      <b-navbar-item tag="router-link" to="/promotions" v-if="elevated"
        >Promotions</b-navbar-item
      >

      <b-navbar-item tag="router-link" to="/referalcodes" v-if="elevated"
        >Referalcodes</b-navbar-item
      >


      
      <b-navbar-item tag="router-link" to="/giftcards" v-if="(elevated || giftCardsEnabled)"
        >Wertgutscheine</b-navbar-item
      >
      <!-- <b-navbar-dropdown label="Bestellungen">
        <b-navbar-item tag="router-link" to="/bestellungen"
          >Abgeschlossene</b-navbar-item
        >
      </b-navbar-dropdown> -->

      <b-navbar-item v-if="!onlyStatistics" tag="router-link" to="/bestellungen"
        >Bestellungen</b-navbar-item
      >

      <b-navbar-item v-if="showStatistics" tag="router-link" to="/statistik"
        >Statistik</b-navbar-item
      >

      <b-navbar-dropdown label="Inhalte" v-if="editor">
        <b-navbar-item
          tag="router-link"
          :to="{name: 'content-overview'}"
          v-if="editor"
          >Übersicht</b-navbar-item
        >
        <b-navbar-item
          tag="router-link"
          :to="{name: 'content-pages'}"
          v-if="editor"
          >Seiten</b-navbar-item
        >

        <b-navbar-item
          tag="router-link"
          :to="{name: 'content-home'}"
          v-if="editor"
          >Startseite</b-navbar-item
        >

        <b-navbar-item
          tag="router-link"
          :to="{name: 'content-menu'}"
          v-if="editor"
          >Menüführung</b-navbar-item
        >
      </b-navbar-dropdown>

      <b-navbar-dropdown label="Administrativ" v-if="supervisor">
        <b-navbar-item
          tag="router-link"
          :to="{name: 'create-user'}"
          v-if="supervisor"
          >Benutzer anlegen</b-navbar-item
        >
        <b-navbar-item
          tag="router-link"
          v-if="elevated"
          to="/admin/user-management"
          >Benutzer verwalten</b-navbar-item
        >
        <b-navbar-item tag="router-link" v-if="elevated" to="logs"
          >Logs</b-navbar-item
        >
        <b-navbar-item tag="router-link" v-if="elevated" to="jobs"
          >Jobs</b-navbar-item
        >
      </b-navbar-dropdown>
    </template>

    <template slot="end">
      <b-navbar-item tag="div">
        <b-button @click="logout" type="is-primary" outlined inverted
          >Logout</b-button
        >
      </b-navbar-item>
    </template>
  </b-navbar>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  name: 'Navigation',
  computed: {
    ...mapGetters({
      supervisor: 'supervisor',
      elevated: 'elevated',
      editor: 'isEditor',
      promoEnabled: 'promoEnabled',
      showStatistics: 'showStatistics',
      onlyStatistics: 'onlyStatistics',
      giftCardsEnabled: 'giftCardsEnabled',
    }),
  },
  methods: {
    logout() {
      //todo validate
      this.$store.dispatch('logout')
    },
  },
}
</script>
<style lang="scss" scoped>
.navbar-item img {
  max-height: 3.4rem;
}
</style>
